import requestCtxs from '@/sealFilter/requestCtxs'

// 周排行榜
export function byweek (data) {
    return requestCtxs({
        url: '/portal/ttv3/portal/user/visitlog/query/ranking/byweek',
        method: 'post',
        data
    })
}

// 月排行榜
export function bymonth (data) {
    return requestCtxs({
        url: '/portal/ttv3/portal/user/visitlog/query/ranking/bymonth',
        method: 'post',
        data
    })
}

// 详情页阅读次数
export function ebookid (data) {
    return requestCtxs({
        url: '/portal/ttv3/portal/user/visitlog/query/by/ebookid',
        method: 'post',
        data
    })
}

// 读这本书的人也读过
export function alsoread (data) {
    return requestCtxs({
        url: '/portal/ttv3/portal/user/visitlog/query/books/alsoread',
        method: 'post',
        data
    })
}

//浏览历史
export function updateByid (data) {
    return requestCtxs({
        url: '/portal/ttv3/portal/user/visitlog/query/by/userid',
        method: 'post',
        data
    })
}
genarate

//生成二维码
export function genarate (data) {
    return requestCtxs({
        url: '/core/ttv3/portal/qrcode/genarate',
        method: 'post',
        data
    })
}
//新增田田阅读用户数据页面操作日志
export function addId (data) {
    return requestCtxs({
        url: '/portal/ttv3/portal/user/visitlog/add',
        method: 'post',
        data
    })
}

//页面访问权限验证控制器
export function authCheck (data) {
    return requestCtxs({
        url: '/auth/ttv3/security/core/page/visit/auth/check',
        method: 'post',
        data
    })
}

//高级检索
export function HighSearch (data) {
    return requestCtxs({
        url: '/core/ttv3/core/datahandle/ebook/search/advanced',
        method: 'post',
        data
    })
}

//高级检索查询
//学科分类
export function classifyType (data) {
    return requestCtxs({
        url: '/core/ttv3/core/classify/typeinfo/query/bycondition',
        method: 'post',
        data
    })
}
//中图法分类
export function subjectType (data) {
    return requestCtxs({
        url: '/core/ttv3/core/subject/typeinfo/query/bycondition',
        method: 'post',
        data
    })
}

//详情页下载
export function detailDownload (data) {
    return requestCtxs({
        url: '/core/ttv3/core/ebook/download/third',
        method: 'post',
        data
    })
}
//查询电子书征订目录信息
export function catalogInfoList (data) {
    return requestCtxs({
        url: '/portal/ttv3/portal/subscript/cataloginfo/query/bypage',
        method: 'post',
        data
    })
}
export function catalogInfoDetail (data) {
    return requestCtxs({
        url: '/portal/ttv3/portal/subscript/catalogdata/query/bypage',
        method: 'post',
        data
    })
}


// WEBPACK FOOTER //
// ./src/api/visitlog.js